import styled, {css} from 'styled-components';

/** Lista de ranking (melhores/piores pares) */
export const RankingList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`;

export const RankingColHeader = styled.li`
    padding: 0 0 10px !important;
    margin-bottom: 4px;
    border-bottom: 1px solid rgba(242, 146, 5, 0.2) !important;
    background: transparent !important;
`;

export const RankingColHeaderInner = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) 92px;
    align-items: center;
    gap: 10px;
    width: 100%;
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgba(200, 210, 235, 0.8);

    span:first-child {
        text-align: left;
        min-width: 0;
    }

    span:last-child {
        text-align: center;
        justify-self: stretch;
    }
`;

export const RankingRow = styled.li`
    padding: 12px 0 !important;
    border: none !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;
    background: transparent !important;

    &:last-child {
        border-bottom: none !important;
    }
`;

export const RankingRowInner = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) 92px;
    align-items: center;
    gap: 10px;
    width: 100%;
`;

export const RankingProgressTrack = styled.div`
    width: 100%;
    min-width: 0;
    height: 28px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.4);
    box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.45);
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.07);
`;

const fillBase = css`
    height: 100%;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 10px;
    box-sizing: border-box;
    transition: width 0.35s ease;
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.2);

    span {
        font-size: 0.7rem;
        font-weight: 800;
        color: rgba(255, 255, 255, 0.98);
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
        white-space: nowrap;
    }
`;

export const RankingProgressFillWin = styled.div`
    ${fillBase};
    background: linear-gradient(90deg, #13855c 0%, #1cc88a 45%, #3dd9a0 100%);
`;

export const RankingProgressFillLoss = styled.div`
    ${fillBase};
    background: linear-gradient(90deg, #a83228 0%, #e74a3b 50%, #ff7a6e 100%);
`;

export const RankingPairLabel = styled.span`
    display: block;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: rgba(245, 248, 255, 0.98);
    padding: 6px 8px;
    border-radius: 10px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: linear-gradient(
        145deg,
        rgba(242, 146, 5, 0.12) 0%,
        rgba(242, 146, 5, 0.06) 100%
    );
    border: 1px solid rgba(242, 146, 5, 0.28);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
`;
